import React, { Component } from 'react'
import { ActivityIndicator } from 'antd-mobile'
import injectSheet from 'react-jss'
import cx from 'classnames'
import styles from '../../assets/styles/components/Checkout'
import lang from 'lodash/lang'
import CheckOutItemContainer from '../../containers/components/CheckoutItem'
import DialogComponent from '../../containers/hoc/Dialog'

class CheckoutComponent extends Component {
  constructor (props) {
    super(props)
    this.state = {
      isOpenModal: false,
      isLoading: false,
    }
  }

    componentDidMount = () => {
      const {
        basket,
        merchant,
        isHistory,
        isCheckoutComplete,
        getOrderHistories,
        isSwitchOnRightSideBar,
        switchRightSideBar,
      } = this.props

      window.scrollTo(0, 0)

      if (isHistory || isCheckoutComplete) {
        if (isSwitchOnRightSideBar) switchRightSideBar(false)
        if (merchant) {
          this.setState({ isLoading: true })
          getOrderHistories(merchant.id, basket.isFilteredByMe).then(() => {
            this.setState({ isLoading: false })
          })

          if (!this.interval) {
            this.interval = setInterval(() => {
              getOrderHistories(merchant.id, basket.isFilteredByMe).then(() => {
                this.setState({ isLoading: false })
              })
            }, 60 * 1000)
          }
        }
      }
    }

    componentDidUpdate = (prevProps) => {
      const {
        basket,
        merchant,
        isHistory,
        getOrderHistories,
      } = this.props

      if (!merchant) return
      if (merchant !== prevProps.merchant) {
        if (isHistory && prevProps.isHistory) {
          this.setState({ isLoading: true })
          getOrderHistories(merchant.id, basket.isFilteredByMe).then(() => {
            this.setState({ isLoading: false })
          })
        }
      } else {
        // same merchant
        if (basket.isFilteredByMe !== prevProps.basket.isFilteredByMe) {
          getOrderHistories(merchant.id, basket.isFilteredByMe).then(() => {
            this.setState({ isLoading: false })
          })
        }
      }
    }

    componentWillUnmount = () => {
      // const { switchEditMode } = this.props
      // switchEditMode(false)
      if (this.interval) clearInterval(this.interval)
    }

    openResetModal = () => this.setState({ isOpenModal: true })

    confirmResetBasket = async (confirm) => {
      const { switchClearAllOrdersMode } = this.props
      switchClearAllOrdersMode(false)
      this.setState({ isOpenModal: false })
      if (confirm) {
        const {
          resetBasket,
          resetOrder,
          resetStash,
          history,
        } = this.props
        await Promise.all([resetOrder(), resetStash(), resetBasket()])
        const path = '/home'
        history.push(path)
        console.info('route changed', path)
      }
    }

    renderEmptyBasket = () => {
      const { intl, classes } = this.props

      const _emptyOrderText = intl.formatMessage({ id: 'checkout.empty_order' })
      const basketEmptyMessageStyle = cx(classes['basket-empty-message'])

      return (
        <div className={basketEmptyMessageStyle}>
          {_emptyOrderText}
        </div>
      )
    }

    renderDialogComponent = () => {
      const {
        intl,
        isSwitchClearAllOrdersMode,
      } = this.props

      const _dialogTitleText = intl.formatMessage({ id: 'dialog.remind' })
      const _dialogMsgText = intl.formatMessage({ id: 'dialog.confirm_clear_order_all' })

      if (isSwitchClearAllOrdersMode) {
        return (
          <DialogComponent
            triggerModal={this.confirmResetBasket}
            dialogType='confirm'
            title={_dialogTitleText}
            message={_dialogMsgText}
          />
        )
      }
    }

    renderActivityIndicator = () => {
      const { classes } = this.props
      const { isLoading } = this.state

      const activityIndicatorWrapStyle = cx(classes['activity-indicatior-wrap'])

      if (isLoading) {
        return (
          <div className={activityIndicatorWrapStyle}>
            <ActivityIndicator size='large' />
          </div>
        )
      }
    }

    render () {
      const {
        order,
        basket,
        classes,
        history,
        historyList,
        isHistory,
        isCheckoutComplete,
        isTakeaway,
        setBasketRemark,
      } = this.props

      const path = history.location.pathname
      const isCheckout = path === '/basket/checkout'
      const isTakeawaySummary = path === '/basket/takeaway_summary'

      const wrapStyle = cx(classes.wrap)

      const switchList = () => {
        if (isCheckoutComplete) {
          return historyList.filter(order => order.status === 'paid')
        } else if (isHistory) {
          return historyList
        } else return order.list
      }
      const list = switchList()

      const remarks = {}
      if (isCheckout) {
        list.forEach((order, index) => {
          remarks[index] = order.remarks
        })
      } else if (isHistory || isTakeawaySummary || isCheckoutComplete) {
        historyList.forEach((ele) => {
          const tmp = {}
          ele.items.forEach((item, index) => {
            tmp[index] = item.remarks
          })
          remarks[ele.id] = tmp
        })
      }

      return (
        <div className={wrapStyle}>
          {this.renderActivityIndicator()}
          <CheckOutItemContainer
            list={list}
            basket={basket}
            isSwitchOnEditMode
            isHistory={isHistory}
            isCheckoutComplete={isCheckoutComplete}
            selectedRemarkItems={remarks}
            setBasketRemark={setBasketRemark}
            hideRemarkField={!isTakeaway}
          />
          {!isHistory && lang.isEmpty(list) && this.renderEmptyBasket()}
          {this.renderDialogComponent()}
        </div>
      )
    }
};

/**
 * Export
 */
export default injectSheet(styles)(CheckoutComponent)



// WEBPACK FOOTER //
// ./src/components/scenes/Checkout.js